<template>
  <div
    :class="ifMobile ? 'nofixed' : 'fixed'"
    v-if="showChuangguan || ifMobile"
  >
    <report v-if="curPage === 'report'"></report>
    <chuangguanInfo
      v-if="curPage === 'chuangguanInfo'"
      @changeTab="changeTab(item)"
    ></chuangguanInfo>
    <chuangguan v-if="curPage === 'chuangguan'"></chuangguan>
    <bonusLesson v-if="curPage === 'bonusLesson'"></bonusLesson>
    <lessonSys v-if="curPage === 'lessonSys'"></lessonSys>
    <div
      class="qrcode-wrap"
      v-if="!ifMobile && showQrcode"
      @click.self="showQrcode = false"
    >
      <img
        :src="qrcodeSrc"
        alt=""
      />
      <span style="font-size: 24px;color: #fff;margin-top: 30px;">手机微信扫码后即可在手机上学习</span>
    </div>
    <div
      class="qrcode-tips"
      @click="showQrcode = !showQrcode"
      v-if="!ifMobile"
    >去手机上学习</div>
    <!-- <img
      :src="qrcodeSrc"
      alt=""
      @click="showQrcode = true"
      v-if="!ifMobile"
      class="qrcode"
    /> -->
    <div class="tab">
      <div
        class="tab-item"
        :class="curPage === 'report' ? 'active' : ''"
        @click="curPage = 'report'"
      >
        <img
          src="./img/home-s.png"
          alt=""
        />
        <!-- <img
          src="./img/home.png"
          alt=""
          v-else
        /> -->
        <span>定制报告</span>
      </div>

      <div
        class="tab-item"
        :class="curPage === 'chuangguan' ? 'active' : ''"
        @click="curPage = 'chuangguan'"
      >
        <img
          src="./img/game-s.png"
          alt=""
        />
        <!-- <img
          src="./img/game.png"
          alt=""
          v-else
        /> -->
        <span>开始闯关</span>
      </div>
      <div
        class="tab-item"
        :class="curPage === 'chuangguanInfo' ? 'active' : ''"
        @click="curPage = 'chuangguanInfo'"
      >
        <img
          src="./img/my-s.png"
          alt=""
        />
        <!-- <img
          src="./img/my.png"
          v-else
          alt=""
        /> -->
        <span>个人界面</span>
      </div>
      <!-- <div class="tab-item" :class="curPage === 'bonusLesson' ? 'active' : ''" @click="curPage = 'bonusLesson'">
        <img src="./img/lesson-s.png" alt="" v-if="curPage === 'bonusLesson'" />
        <img src="./img/lesson.png" alt="" v-else />
        <span>选修课表</span>
      </div> -->
      <!-- <div class="tab-item" :class="curPage === 'lessonSys' ? 'active' : ''" @click="curPage = 'lessonSys'">
        <img src="./img/sys-s.png" alt="" v-if="curPage === 'lessonSys'" />
        <img src="./img/sys.png" alt="" v-else />
        <span>课程体系</span>
      </div> -->
    </div>
  </div>
</template>
<script>
import report from './report'
import chuangguanInfo from './chuangguanInfo'
import chuangguan from './chuangguan'
import bonusLesson from './bonusLesson'
import lessonSys from './lessonSys'
import cookies from 'js-cookie'
import QRCode from 'qrcode'
// import { getQueryString } from '../../../project/src/constant/utils'
export default {
  components: { report, chuangguanInfo, chuangguan, bonusLesson, lessonSys },
  data() {
    return {
      showChuangguan: false,
      showQrcode: false,
      curPage: 'report',
      ifMobile: false,
      qrcodeSrc: '',
    }
  },
  methods: {
    changeTab(item) {
      this.curPage = item
    },
    toggle() {
      this.showChuangguan = !this.showChuangguan
    },
    getQrcode() {
      let jwt = cookies.get('feathers-jwt')
      if (jwt !== this.$route.query.jwt && this.$route.query.jwt) {
        jwt = this.$route.query.jwt
      }
      if (!jwt) {
        return
      } else {
        let cookie
        cookie = `feathers-jwt=${jwt};expires=`
        cookie += new Date(Date.now() + 1000 * 60 * 60 * 24).toGMTString()
        document.cookie = cookie
      }
      QRCode.toDataURL(`${location.origin}/#/chuangguan?jwt=${jwt}&ifMobile=1`).then((imgData) => {
        if (imgData) {
          this.qrcodeSrc = imgData
        }
      })
    },
  },
  mounted() {
    this.ifMobile = Boolean(this.$route.query.ifMobile)
    this.getQrcode()
    if (this.$route.query.jwt) {
      location.hash = '#/chuangguan?ifMobile=1'
    }
  },
}
</script>
<style scoped>
.qrcode {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  z-index: 9;
  cursor: pointer;
}
.qrcode-wrap {
  /* width: 100vw; */
  /* height: 100vh; */
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.qrcode-wrap img {
  width: 320px;
  height: 320px;
}
.fixed {
  position: fixed;
  width: 550px;
  right: 0;
  top: 60px;
  z-index: 99;
  filter: drop-shadow(-2px 0 6px #999);
}
.nofixed {
  width: 100vw;
}
.chuangguan {
  width: 100%;
  background-color: #574171;
}
.comp >>> .index {
  width: 550px;
  height: calc(100vh - 60px);
  overflow: auto;
}
.mobile >>> .index {
  width: 100vw;
}
.chuangguan >>> .index {
  margin: 0 auto;
  background-color: #fff;
}
.fixed .tab {
  position: absolute;
}
.fixed >>> .menu {
  position: absolute;
}
.nofixed .tab {
  width: 100vw;
  height: 58px;
}
.nofixed .tab-item {
  height: 58px;
  font-size: 14px;
}
.nofixed .tab-item img {
  width: 20px;
  height: 20px;
  display: block;
  margin-bottom: 8px;
}
.nofixed >>> .menu {
  bottom: 68px;
}
.tab {
  width: 550px;
  height: 118px;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  border-top: 1px solid #dfdfdf;
  border-image: linear-gradient(90deg, rgba(228, 3, 93, 0.3), rgba(56, 173, 253, 0.3)) 10 10;
  background: #141921;
}
.tab-item {
  width: 20%;
  flex-grow: 1;
  height: 118px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  font-size: 18px;
  color: rgb(255, 255, 255);
  cursor: pointer;
}
.tab-item img {
  width: 32px;
  height: 32px;
  display: block;
  margin-bottom: 18px;
  filter: grayscale(1);
}
.tab-item:last-of-type {
  border-right: none;
}
.active {
  border-top: 2px solid #dfdfdf;
  background-image: linear-gradient(90deg, rgba(228, 3, 93), rgba(56, 173, 253));
  -webkit-background-clip: text;
  background-clip: text;
  color: rgba(56, 173, 253);
  border-image: linear-gradient(90deg, rgba(228, 3, 93), rgba(56, 173, 253)) 10 10;
}
.active img {
  filter: grayscale(0);
}
.qrcode-tips {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 18px;
  width: 130px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  padding: 0 10px;
  z-index: 9;
  cursor: pointer;
  color: #fff;
  background-color: #06edf694;
}
</style>
